/**
 * Turn a failed request into something the person at the screen can read.
 *
 * The API answers `{ data, errors, meta }`, and `errors` is either `{ detail: "..." }`
 * or DRF's per-field `{ order: ["..."], amount: ["..."] }`. The create form used to
 * discard the whole thing: a refusal the backend had spelled out — "To zamówienie nie
 * zezwala podwykonawcy na składanie prośb o opłatę urzędową" — reached the user as a
 * button that did nothing.
 */
export function extractApiError(err: unknown): string {
  const response = (err as { response?: { data?: { errors?: unknown } } })?.response;
  const errors = response?.data?.errors;
  if (typeof errors === "string") return errors;
  if (errors && typeof errors === "object") {
    const messages = Object.values(errors as Record<string, unknown>)
      .flat()
      .map((v) => String(v))
      .filter(Boolean);
    if (messages.length) return messages.join(" ");
  }
  return "Nie udało się złożyć prośby. Spróbuj ponownie lub zgłoś to administratorowi.";
}
